// eslint-disable-next-line import/prefer-default-export
export const LIMIT_DEFAULT = 10;
